import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import MidPageBanner from 'Components/Banner/MidPageBanner/MidPageBanner';

const PreviewFooterBanner = ({
  midPageBanner,
}) => {
  if (isEmpty(midPageBanner)) return false;

  const background = midPageBanner.images.find(img => img.img_type === 'mid_page_banner_background');
  const foreground = midPageBanner.images.find(img => img.img_type === 'mid_page_banner_foreground');
  const mobile = midPageBanner.images.find(img => img.img_type === 'mid_page_banner_mobile');

  return (
    <div className="PreviewMidPageBanner container">
      <h1 className="pt-5">Mid Page Banner Preview</h1>
      <div className="PreviewMidPageBanner__mobilePreviewContainer pt-5">
        <h3>Mobile Banner</h3>
        <div className="PreviewMidPageBanner__mobilePreview">
          <MidPageBanner
            mobileOverride
            url={midPageBanner.url}
            background={get(background, 'img')}
            foreground={get(foreground, 'img')}
            mobile={get(mobile, 'img')}
            externalLink={midPageBanner.external_link}
          />
        </div>
      </div>

      <div className="PreviewMidPageBanner__desktopPreviewContainer">
        <h3>Desktop Banner</h3>
        <MidPageBanner
          url={midPageBanner.url}
          background={get(background, 'img')}
          foreground={get(foreground, 'img')}
          mobile={get(mobile, 'img')}
          externalLink={midPageBanner.external_link}
        />
      </div>
    </div>
  );
};

PreviewFooterBanner.propTypes = {
  footer: PropTypes.shape({}),
};

PreviewFooterBanner.defaultProps = {
  footer: {},
};

export default PreviewFooterBanner;
